/**
 * Formats a date to be used in a field of input type "date"
 *
 * @param date - The date to format.
 *
 * @returns A string in YYYY-MM-DD format.
 */

export const formatDateForInput = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
